export class TipoPlazo {
    constructor(
        public id?: number,
        public descripcion?: string
    ) { }
}
